exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-pages-sandr-heating-index-tsx": () => import("./../../../src/pages/sandr-heating/index.tsx" /* webpackChunkName: "component---src-pages-sandr-heating-index-tsx" */),
  "component---src-pages-sandr-heating-sandr-heating-tsx": () => import("./../../../src/pages/sandr-heating/SandrHeating.tsx" /* webpackChunkName: "component---src-pages-sandr-heating-sandr-heating-tsx" */)
}

